import React, { useEffect, useState } from "react";
import styles from "./CouncilPage.module.scss";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import LoaderButton from "../../Molecules/Loader/LoaderButton";
import ApplicantsTab from "../../Atoms/Tabs/ApplicantsTab";
import TopHeader from "../../Molecules/SpeechAndTestimonials/TopHeader";
import studentsIcon from "../../../assets/Imagess/student-icon.svg";
import parentsIcon from "../../../assets/Imagess/parents-icon.svg";
import cadetsIcon from "../../../assets/Imagess/cadets-icon.svg";
import facultyIcon from "../../../assets/Imagess/faculty-icon.svg";
import councilCalendarIcon from "../../../assets/Imagess/council-calendar-icon.svg";
import CouncilActivityHeader from "../../Molecules/Council/CouncilActivityHeader";
import {
  useFetchCouncilCalendar,
  useFetchCouncilNews,
  useFetchCouncilTeams,
} from "../../../Hooks/Council";
import CouncilMemberCard from "../../Molecules/Council/CouncilMemberCard";
import CouncilNewsCard from "../../Molecules/Council/CouncilNewsCard";
import TablePagination from "../../Molecules/Pagination/TablePagination";
import CouncilCalendarCard from "../../Molecules/Council/CouncilCalendarCard";
import { debounce, isEmpty } from "lodash";
import Loader from "../../Molecules/Loader/Loader";
import NoDataComponent from "../../Molecules/Custom/NoDataComponent/NoDataComponent";

const CouncilPage = () => {
  const { active } = useParams();
  const location = useLocation();
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState("students");
  const navigate = useNavigate();
  const [selectedActivity, setSelectedActivity] = useState(
    location?.state?.selectedActivity || false
  );
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const tabs = [
    { index: 0, name: "students", text: "Students", icon: studentsIcon },
    {
      index: 1,
      name: "parents",
      text: "Parents",
      icon: parentsIcon,
    },
    {
      index: 2,
      name: "cadets-students",
      text: "Cadets Students",
      icon: cadetsIcon,
    },
    {
      index: 3,
      name: "faculty-members",
      text: "Faculty Members",
      icon: facultyIcon,
    },
    {
      index: 4,
      name: "council-calendar",
      text: "Council Calendar",
      icon: councilCalendarIcon,
    },
  ];

  const { data: calendar, refetch: refetchCalendar } =
    useFetchCouncilCalendar();

  const { data, refetch, isLoading } = useFetchCouncilTeams(
    "students" === selected
      ? 0
      : "parents" === selected
      ? 1
      : "cadets-students" === selected
      ? 2
      : "faculty-members" === selected
      ? 3
      : 4,
    search
  );

  const {
    data: news,
    refetch: refetchNews,
    isLoading: isLoadingNews,
  } = useFetchCouncilNews(
    pageSize,
    page,
    "students" === selected
      ? 0
      : "parents" === selected
      ? 1
      : "cadets-students" === selected
      ? 2
      : "faculty-members" === selected
      ? 3
      : 4,
    search
  );

  const itemsPerPage = news?.data?.pageSize;
  const totalItems = news?.data?.totalCount;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  useEffect(() => {
    setSelected(active);
  }, [active]);

  useEffect(() => {
    refetchNews();
  }, [selectedActivity]);

  useEffect(() => {
    if ("council-calendar" === selected) {
      refetchCalendar();
      return;
    }
    refetch();
  }, [selected]);

  useEffect(() => {
    handleSearch();
  }, [search]);

  const handleSearch = debounce(() => {
    if (!selectedActivity) {
      refetch();
    } else {
      refetchNews();
    }
  }, 300);

  const handleNavigate = (e) => {
    e.preventDefault();

    if ("council-calendar" === selected) {
      navigate("/home/create-council-calendar");
      return;
    }

    if (!selectedActivity) {
      navigate(
        `/home/add-council-member/${
          "students" === selected
            ? 0
            : "parents" === selected
            ? 1
            : "cadets-students" === selected
            ? 2
            : "faculty-members" === selected
            ? 3
            : 4
        }`
      );
    } else {
      navigate(
        `/home/add-council-news/${
          "students" === selected
            ? 0
            : "parents" === selected
            ? 1
            : "cadets-students" === selected
            ? 2
            : "faculty-members" === selected
            ? 3
            : 4
        }`
      );
    }
  };

  useEffect(() => {
    setSearch("");
    refetch();
    refetchNews();
  }, [selected, selectedActivity]);

  return (
    <div>
      <div className={styles["tab-container"]}>
        {tabs.map((tab) => (
          <ApplicantsTab
            key={tab.index}
            text={tab.text}
            handleOnClick={() => {
              navigate(`/home/council/${tab.name}`);
            }}
            icon={tab.icon}
            active={tab.name === selected ? true : false}
            shadowed={false}
          />
        ))}
      </div>
      <TopHeader
        search={search}
        setSearch={setSearch}
        handleNewClick={handleNavigate}
        buttonTitle={
          "council-calendar" === selected
            ? "New Calendar"
            : !selectedActivity
            ? "New Member"
            : "Create News"
        }
      />
      {"council-calendar" !== selected && (
        <CouncilActivityHeader
          selectedActivity={selectedActivity}
          setSelectedActivity={setSelectedActivity}
          newsTitle={
            "students" === selected
              ? "Students Council News"
              : "parents" === selected
              ? "Parents Council News"
              : "cadets-students" === selected
              ? "Cadets Students Council News"
              : "faculty-members" === selected
              ? "Faculty Members Council News"
              : ""
          }
        />
      )}
      <div className={styles["table-container"]}>
        {selected !== "council-calendar" ? (
          isLoading || isLoadingNews ? (
            <Loader />
          ) : !selectedActivity ? (
            data?.data?.length > 0 ? (
              <div className={styles["major-box-grid"]}>
                {data?.data?.map((x) => (
                  <CouncilMemberCard
                    data={x}
                    refetch={refetch}
                    selected={selected}
                    key={x?.councilTeamId}
                  />
                ))}{" "}
              </div>
            ) : (
              <NoDataComponent />
            )
          ) : news?.data?.items?.length > 0 ? (
            <div className={styles["major-box-grid"]}>
              {news?.data?.items.map((x) => (
                <CouncilNewsCard
                  program={x}
                  refetch={refetchNews}
                  selected={selected}
                  key={x?.newsId}
                />
              ))}
            </div>
          ) : (
            <NoDataComponent />
          )
        ) : calendar?.data?.length > 0 ? (
          <div className={styles["major-box-grid"]}>
            {calendar?.data?.map((x) => (
              <CouncilCalendarCard
                calendar={x}
                refetch={refetchCalendar}
                key={x?.councilCalendarId}
              />
            ))}
          </div>
        ) : (
          <NoDataComponent />
        )}

        {selectedActivity && (
          <TablePagination
            totalPages={totalPages}
            page={page}
            setPage={setPage}
            itemsPerPage={pageSize}
            setPageSize={setPageSize}
          />
        )}
      </div>
    </div>
  );
};

export default CouncilPage;
